module.exports = __webpack_public_path__ + "img/pic_button_suspend_en@2x.b1079e77.png";